import React from 'react';
import { connect } from 'react-redux';
import {
  deepEquals,
  concatenateGeosuggestLabel,
  concatenateAddressLabel
} from '../../../lib/utils';

import Geosuggest from 'react-geosuggest';

import AddressModal from './AddressModal';
import GeoSuggestWrapper from './GeoSuggestWrapper';
import ManualAddress from './ManualAddress';

import NavigationComponent from '../util/NavigationComponent';
import Select from '../util/Select';
import FadeOutErrorMessage from '../util/FadeOutErrorMessage';

class AddressAutocomplete extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      noSuggestionsError: false,
      invalidAddressError: false,
      invalidAddressCity: false,
      showModals: {
        addressNotFound: false
      },
      addressLabel: !this.props.address
        ? ''
        : this.props.address.isManual
        ? concatenateAddressLabel(this.props.address)
        : concatenateGeosuggestLabel(this.props.address)
    };

    this.clearAllErrors = this.clearAllErrors.bind(this);
    this.updateSuggestions = this.updateSuggestions.bind(this);
    this.noSuggestions = this.noSuggestions.bind(this);
    this.onSuggestSelect = this.onSuggestSelect.bind(this);
    this.updateErrors = this.updateErrors.bind(this);
  }

  noSuggestionsError = 'noSuggestionsError';
  invalidAddressError = 'invalidAddressError';
  invalidAddressCity = 'invalidAddressCity';

  componentWillReceiveProps(nextProps) {
    if (this.state.addressLabel && deepEquals(nextProps.address, {}))
      this.setState({ addressLabel: '' });
  }

  clearAllErrors() {
    if (this.state.noSuggestionsError) this.updateErrors(this.noSuggestionsError, false);
    else if (this.state.invalidAddressError) {
      this.updateErrors(this.invalidAddressError, false);
    } else if (this.state.invalidAddressCity) this.updateErrors(this.invalidAddressCity, false);
  }

  updateSuggestions(suggestions) {
    if (suggestions.length && this.state.addressLabel) this.clearAllErrors();
  }

  noSuggestions() {
    if (this._geoSuggest.props.value !== '') {
      this.updateErrors(this.noSuggestionsError, true);
    }
  }

  onBlur() {
    if (
      (deepEquals(this.props.address, {}) ||
        deepEquals(
          {
            streetNumber: this.props.address.streetNumber,
            street: this.props.address.street,
            city: this.props.address.city,
            state: this.props.address.state,
            zip: this.props.address.zip,
            country: this.props.address.country
          },
          {
            streetNumber: '',
            street: '',
            city: '',
            state: '',
            zip: '',
            country: ''
          }
        )) &&
      this.state.addressLabel &&
      !this.state.noSuggestionsError &&
      !this.state.invalidAddressCity
    ) {
      this.updateErrors(this.invalidAddressError, true);
    } else if (this.state.invalidAddressError) {
      this.updateErrors(this.invalidAddressError, false);
    }
  }

  saveManualAddress(address) {
    this.toggleModal('addressNotFound');
    this.setState({
      addressLabel: concatenateAddressLabel(
        {
          ...address,
          unitType: address.unitType
            ? this.props.unitTypes.filter(type => type.key === address.unitType).length
              ? this.props.unitTypes.filter(type => type.key === address.unitType)[0].value
              : ''
            : '' || ''
        },
        this.props.isIsraeli
      )
    });
    let validCity = true;
    if (this.props.validateAddress) validCity = this.props.validateAddress(address);
    if (!validCity) {
      this.updateErrors(this.invalidAddressCity, true);
    } else if (this.state.invalidAddressCity) this.updateErrors(this.invalidAddressCity, false);

    this.props.updateAddress({ ...address, isManual: true });
  }

  clearManualAddress() {
    this.setState({ addressLabel: '' });
    this.clearAllErrors();
    this.props.updateAddress({
      ...this.props.address,
      streetNumber: '',
      street: '',
      unitType: '',
      apartment: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      isManual: false
    });
  }

  clearAndShowAddressModal() {
    this.props.updateAddress({
      ...this.props.address,
      streetNumber: '',
      street: '',
      unitType: '',
      apartment: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    });
    this.setState(
      {
        addressLabel: '',
        noSuggestionsError: false,
        invalidAddressError: false,
        invalidAddressCity: false
      },
      () => {
        this.props.updateError(false);
        this.toggleModal('addressNotFound');
      }
    );
  }

  updateAddressLabel(e) {
    this.props.updateAddress({
      ...this.props.address,
      streetNumber: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    });
    this.setState({ addressLabel: e });
    if (!e) this.clearAllErrors();
  }

  onSuggestSelect(suggestion) {
    if (suggestion && suggestion.gmaps && suggestion.gmaps.address_components) {
      let { address_components } = suggestion.gmaps;
      let address = { ...this.props.address };
      address.streetNumber = address_components.find(obj => obj.types.includes('street_number'))
        ? address_components.find(obj => obj.types.includes('street_number')).long_name
        : '';
      address.street = address_components.find(obj => obj.types.includes('route'))
        ? address_components.find(obj => obj.types.includes('route')).long_name
        : '';
      address.city = address_components.find(obj => obj.types.includes('locality'))
        ? address_components.find(obj => obj.types.includes('locality')).long_name
        : '' || address_components.find(obj => obj.types.includes('sublocality'))
        ? address_components.find(obj => obj.types.includes('sublocality')).long_name
        : '';
      address.state = address_components.find(obj =>
        obj.types.includes('administrative_area_level_1')
      )
        ? address_components.find(obj => obj.types.includes('administrative_area_level_1'))
            .long_name
        : '';
      address.country = address_components.find(obj => obj.types.includes('country'))
        ? address_components.find(obj => obj.types.includes('country')).long_name
        : '';
      address.zip = address_components.find(obj => obj.types.includes('postal_code'))
        ? address_components.find(obj => obj.types.includes('postal_code')).long_name
        : '';
      let validCity = true;
      if (this.props.validateAddress) validCity = this.props.validateAddress(address);
      if (!validCity || !address.streetNumber || !address.street || !address.country) {
        if (validCity) {
          this.updateErrors(this.invalidAddressError, true);
        } else {
          this.updateErrors(this.invalidAddressCity, true);
        }
        this.setState({ addressLabel: concatenateGeosuggestLabel(address, this.props.isIsraeli) });
        this.props.updateAddress({
          ...this.props.address,
          streetNumber: '',
          street: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        });
        this._geoSuggest.blur();
        return;
      } else if (this.state.invalidAddressError) this.updateErrors(this.invalidAddressError, false);
      else if (this.state.invalidAddressCity) this.updateErrors(this.invalidAddressCity, false);
      this.setState({
        addressLabel: suggestion.label
          ? concatenateGeosuggestLabel(address, this.props.isIsraeli)
          : ''
      });
      this.props.updateAddress({ ...this.props.address, ...address });
      this._geoSuggest.blur();
    }
  }

  updateAddressComponent(e) {
    this.props.updateAddress({ ...this.props.address, [e.target.name]: e.target.value });
  }

  updateErrors(errorName, value) {
    if (
      (errorName === this.invalidAddressError && !this.state.noSuggestionsError) ||
      (errorName === this.invalidAddressCity && !this.state.noSuggestionsError) ||
      errorName === this.noSuggestionsError
    ) {
      this.setState({ [errorName]: value }, () => {
        if (
          this.state.invalidAddressError ||
          this.state.noSuggestionsError ||
          this.state.invalidAddressCity
        )
          this.props.updateError(true);
        else this.props.updateError(false);
      });
    }
  }

  skipSuggestion = suggestion => {
    const isIsrael = this.props.isIsraeli;
    const terms = suggestion.terms || [];
    const lastTerm = terms.length > 0 ? terms[terms.length - 1].value : '';

    const allowedTypes = [
      'geocode',
      'street_address',
      'premise',
      'route',
      'subpremise',
      'locality'
    ];

    const hasAllowedType = suggestion.types.some(type => allowedTypes.includes(type));
    if (!hasAllowedType) return true;

    if (isIsrael && lastTerm !== 'ישראל') return true;
    if (!isIsrael && lastTerm === 'Israel') return true;

    return false;
  };

  render() {
    const requiredErr =
      this.props.showRequiredError &&
      this.props.required &&
      (!this.props.address.streetNumber ||
        !this.props.address.street ||
        !this.props.address.city ||
        !this.props.address.country);
    const validationErr =
      this.state.noSuggestionsError ||
      this.state.invalidAddressError ||
      this.state.invalidAddressCity;

    return (
      <GeoSuggestWrapper isIsraeli={this.props.isIsraeli}>
        {!this.props.hide && //for cases when need to render GeosuggestWrapper in order to update script, but don't want to show input
          (this.props.address.isManual ? (
            <ManualAddress
              clearAddress={this.clearManualAddress.bind(this)}
              editAddress={this.toggleModal.bind(this, 'addressNotFound')}
              manualLabel={this.state.addressLabel}
              addAddressLabel={this.props.addAddressLabel}
              showError={this.props.showRequiredError && this.props.required}
              invalidAddressCity={this.state.invalidAddressCity}
              incomplete={
                !this.props.address.streetNumber ||
                !this.props.address.street ||
                !this.props.address.city ||
                !this.props.address.country
              }
            />
          ) : (
            <div className="address-autocomplete">
              <div>
                <label
                  className={`input-label ${validationErr || requiredErr ? 'error-label' : ''}`}
                >
                  {this.props.title || 'Address'}
                  <span
                    className="link-text small-text"
                    onClick={this.clearAndShowAddressModal.bind(this)}
                  >
                    Address Not Found?
                  </span>
                </label>
                <Geosuggest
                  inputClassName={validationErr || requiredErr ? 'error-input' : ''}
                  tabIndex={this.props.tabIndex || ''}
                  ignoreTab={true}
                  placeholder="Enter Address"
                  queryDelay={250}
                  autoComplete={'on'}
                  ref={el => (this._geoSuggest = el)}
                  value={this.state.addressLabel}
                  initialValue={this.state.addressLabel}
                  onChange={this.updateAddressLabel.bind(this)}
                  onUpdateSuggests={this.updateSuggestions}
                  onBlur={this.onBlur.bind(this)}
                  skipSuggest={this.skipSuggestion}
                  onFocus={this.clearAllErrors}
                  onSuggestSelect={this.onSuggestSelect}
                  types={['geocode', 'establishment']}
                  onSuggestNoResults={this.noSuggestions}
                />
                <FadeOutErrorMessage
                  show={this.state.noSuggestionsError}
                  message="No suggestions, use address not found."
                />
                <FadeOutErrorMessage
                  show={this.state.invalidAddressError}
                  message="Invalid Address"
                />
                <FadeOutErrorMessage
                  show={this.state.invalidAddressCity}
                  message="Invalid address, city must be included in the associated location group."
                />
              </div>
              <div>
                <label className="input-label">Unit Type</label>
                <Select
                  clearable={true}
                  tabIndex={this.props.tabIndex ? this.props.tabIndex + 5 : ''}
                  options={this.props.unitTypes}
                  name="unitType"
                  value={this.props.address.unitType || ''}
                  onChange={this.updateAddressComponent.bind(this)}
                />
              </div>
              <div>
                <label className="input-label">Unit #</label>
                <input
                  type="text"
                  value={this.props.address.apartment || ''}
                  tabIndex={this.props.tabIndex ? this.props.tabIndex + 10 : ''}
                  onChange={this.updateAddressComponent.bind(this)}
                  name="apartment"
                />
              </div>
              {this.props.addAddressLabel && (
                <label className="input-label">{this.props.addAddressLabel}</label>
              )}
            </div>
          ))}

        <AddressModal
          modalShowing={this.state.showModals.addressNotFound}
          address={this.props.address}
          closeModal={this.toggleModal.bind(this, 'addressNotFound')}
          onChange={this.onChange}
          saveAddress={this.saveManualAddress.bind(this)}
          unitTypes={this.props.unitTypes}
          streetNames={this.props.streetNames}
        />
      </GeoSuggestWrapper>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    unitTypes: state.settings.systemSettings.data.otherSettings.unitTypes,
    streetNames: state.settings.systemSettings.data.otherSettings.streetNames
  };
}

export default connect(mapStateToProps, null)(AddressAutocomplete);

//props:
//address (obj), updateAddress (func), udpateError (func), unitTypes (array), required (bool), showRequiredError (bool)
//optional props: validateAddress (func), hideNotFound (bool)



// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/AddressAutocomplete.jsx